import React, { useEffect, useState } from 'react'
import WrapperSection from '../glopal/WrapperSection'
import IntroductorySection from '../glopal/IntroductorySection'
// import ImagesGrid from '../glopal/ImagesGrid'
// import img1 from './../../assets/mission/message.png'
// import img2 from './../../assets/mission/message.png'
import { useGetHomeDataQuery } from '../../state/apiHome'
import i18next from 'i18next'
import CardImg from '../glopal/CardImg'
const OurMission = () => {
    let lng = i18next.language
    const { data, isBrandsLoading } = useGetHomeDataQuery(lng);

    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        if (data && !isBrandsLoading) {
            setTableData(data?.data?.message)
        }
    }, [data, tableData, isBrandsLoading])
    return (
        <>
            <WrapperSection>
                <IntroductorySection width='50%' dir={'row-reverse'} title={tableData?.title} desc={tableData?.description} >
                    <CardImg img={tableData?.image} />
                </IntroductorySection>
            </WrapperSection>
        </>
    )
}

export default OurMission